import { Helper } from '../Helper';
export class TypedHelper extends Helper {
    constructor({ knownType, type }) {
        super();
        this.type = type;
        this.knownType = knownType;
    }
}

//# sourceMappingURL=TypedHelper.js.map
